/* unplugin-vue-components disabled */import script from "./postoperativecare.vue?vue&type=script&setup=true&lang=ts"
export * from "./postoperativecare.vue?vue&type=script&setup=true&lang=ts"

import "./postoperativecare.vue?vue&type=style&index=0&id=8aa5a2fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aa5a2fa"]])

export default __exports__